import { useMemo, useRef, useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import './ArticleImageViewer.css';

export function ArticleImageViewer({ html }) {
  const [image, setImage] = useState(null);
  const opener = useRef(null);
  const body = useRef(null);
  const markup = useMemo(() => ({ __html: html.replaceAll('Открыть оригинал ↗', 'Увеличить изображение') }), [html]);

  function openImage(event) {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a');
    const figure = link?.closest('figure');
    const preview = figure?.querySelector('img');
    if (!link || !preview || !event.currentTarget.contains(figure)) return;
    // Only image/original links; other links in article captions retain their destination.
    const imageLink = figure.querySelector('a:has(img)');
    if (!imageLink || link.href !== imageLink.href) return;
    event.preventDefault();
    opener.current = link;
    setImage({ src: link.href, alt: preview.alt, title: figure.querySelector('figcaption strong')?.textContent || preview.alt || 'Изображение' });
  }

  return <>
    <article ref={body} className="article-body" onClick={openImage} dangerouslySetInnerHTML={markup} />
    <Dialog.Root open={Boolean(image)} onOpenChange={open => { if (!open) setImage(null); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="article-viewer-overlay" />
        <Dialog.Content className="article-viewer-content" aria-describedby={undefined} onCloseAutoFocus={event => { event.preventDefault(); const trigger = opener.current?.isConnected ? opener.current : Array.from(body.current?.querySelectorAll('a') || []).find(link => link.href === opener.current?.href && link.getAttribute('aria-label') === opener.current?.getAttribute('aria-label')); trigger?.focus(); }}>
          <div className="article-viewer-header">
            <Dialog.Title className="article-viewer-title">{image?.title}</Dialog.Title>
            <Dialog.Close className="article-viewer-close" aria-label="Закрыть изображение"><X size={24} /></Dialog.Close>
          </div>
          {image && <img className="article-viewer-image" src={image.src} alt={image.alt} />}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  </>;
}
